import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import pricingStyle from "assets/jss/material-kit-pro-react/views/presentationSections/pricingStyle.js";
import logoM from "assets/img/lgM.png";
const useStyles = makeStyles(pricingStyle);

export default function SectionPricing() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div style={{ padding: 20 }}>
        <GridContainer justify="center">
          <GridItem
            sm={2}
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
            className={classNames(classes.mlAuto, classes.mrAuto)}
          >
            <img alt="ขายส่งเสื้อยืด" src={logoM} width={200} />
          </GridItem>
          <GridItem
            sm={4}
            style={{
              textAlign: "left",
              justifyContent: "center",
              display: "flex",
            }}
            className={classNames(classes.mlAuto, classes.mrAuto)}
          >
            <div>
              <h3>
                <span
                  style={{
                    fontFamily: "Kanit",
                    fontSize: 36,
                    color: "#3C4858",
                    fontWeight: "bold",
                  }}
                  data-mce-style="font-family: Kanit; font-size: 36px; color: #3C4858;"
                >
                  เมอร์คิวรี่ ทีเชิ้ต
                </span>
              </h3>
              <p>
                <span
                  style={{
                    fontFamily: "Kanit",
                    fontSize: 24,
                    color: "#3C4858",
                  }}
                  data-mce-style="font-family: Kanit; font-size: 24px;"
                >
                  ขายส่งเสื้อยืด Cotton 100%
                </span>
                <br />
                <span
                  style={{
                    fontFamily: "Kanit",
                    fontSize: 24,
                    color: "#3C4858",
                  }}
                  data-mce-style="font-family: Kanit; font-size: 24px;"
                >
                  รับผลิตเสื้อยืด ตัดเย็บสกรีนครบวงจร
                </span>
              </p>{" "}
            </div>
          </GridItem>
          <GridItem
            sm={4}
            style={{
              textAlign: "left",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
            className={classNames(classes.mlAuto, classes.mrAuto)}
          >
            <ul style={{ listStyleType: "none" }}>
              <li>
                <span style={{ color: "#3C4858", justifyContent: "left" }}>
                  <strong>
                    <span style={{ fontSize: 18, fontFamily: "Kanit" }}>
                      MercuryTshirt.com
                    </span>
                  </strong>
                </span>
                <br />
                <span style={{ color: "#3C4858", fontFamily: "Kanit" }}>
                  101/106 ประชาสงเคราะห์26 เขตดินแดง แขวงดินแดง กทม 10400
                </span>
              </li>
              <li>
                <span style={{ color: "#3C4858", fontFamily: "Kanit" }}>
                  Email :{" "}
                  <a
                    style={{ color: "#3C4858", fontFamily: "Kanit" }}
                    href="mailto:Mercuryhouse@hotmail.com"
                  >
                    Mercuryhouse@hotmail.com
                  </a>
                  <br />
                  Line@ :{" "}
                  <a
                    style={{ color: "#3C4858", fontFamily: "Kanit" }}
                    href="https://page.line.me/mercurytshirt.com?openQrModal=true"
                  >
                    @mercurytshirt
                  </a>
                  <br />
                </span>
              </li>
              <li className="suop--tel">
                <span
                  style={{ color: "#3C4858", fontFamily: "Kanit" }}
                  data-mce-style="color: #3C4858;"
                >
                  HOTLINE :{" "}
                  <a
                    style={{ color: "#3C4858", fontFamily: "Kanit" }}
                    href="tel:+66853628099"
                    data-mce-href="tel:+66853628099"
                    data-mce-style="color: #3C4858;"
                  >
                    085-362-8099{" "}
                  </a>
                  <br />
                  <span
                    style={{
                      color: "rgb(255, 0, 0)",
                      fontSize: 12,
                      fontFamily: "Kanit",
                    }}
                    data-mce-style="color: #ff0000; font-size: 12px;"
                  >
                    (*ขอความร่วมมือกรุณาดูข้อมูลในเว็บก่อนโทรสอบถามนะคะ )
                  </span>{" "}
                  <br />
                </span>
              </li>
            </ul>
          </GridItem>
          <div>
            <div className={classes.container}>
              <GridContainer>
                <GridItem md={12}>
                  <h4 className={classes.title} style={{ fontFamily: "Kanit" }}>
                    ติดตามข่าวสารเพิ่มเติมจากทางร้าน
                  </h4>
                  <Button
                    style={{ backgroundColor: "#00c402" }}
                    href="https://web.facebook.com/mercurytshirt?_rdc=1&_rdr"
                    round
                  >
                    <i className={"fab fa-line " + classes.marginRight} />
                    LINE
                  </Button>
                  <Button
                    color="facebook"
                    href="https://page.line.me/mercurytshirt.com?openQrModal=true"
                    round
                  >
                    <i className={"fab fa-facebook " + classes.marginRight} />
                    FACEBOOK
                  </Button>
                  <Button
                    color="youtube"
                    href="https://www.youtube.com/channel/UCqvgj54z4tEvKf0Rd5GZcmQ"
                    round
                  >
                    <i className={"fab fa-youtube " + classes.marginRight} />
                    YOUTUBE
                  </Button>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </GridContainer>
      </div>
    </div>
  );
}
